// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__azBDV","SettingTitle":"Header_SettingTitle__pY52+","saveLoading":"Header_saveLoading__o3sVx"};